import type { StreamingChatId } from "@storytell/streaming";
import { createStore } from "solid-js/store";

interface ChatTitle {
  title: string;
}

interface ChatTitleStore {
  titles: Record<StreamingChatId, ChatTitle>;
}

/** Chat titles by chat id, as the backend or a rename last set them. */
export class ChatTitleService {
  private store: ChatTitleStore;
  private setStore: (state: ChatTitleStore | ((prev: ChatTitleStore) => ChatTitleStore)) => void;

  constructor() {
    const [store, setStore] = createStore<ChatTitleStore>({
      titles: {},
    });
    this.store = store;
    this.setStore = setStore;
  }

  /**
   * Get title for a specific chat (reactive)
   */
  getChatTitle(chatId: StreamingChatId): string | undefined {
    // Access store reactively
    return this.store.titles[chatId]?.title;
  }

  /**
   * Set title for a chat (used when loading from backend)
   */
  setChatTitle(chatId: StreamingChatId, title: string): void {
    const chatTitle: ChatTitle = { title };

    this.setStore((prev) => ({
      ...prev,
      titles: { ...prev.titles, [chatId]: chatTitle },
    }));
  }
}
